import React from "react";
import { useLocation } from "react-router";
import OAuthSignIn from "./OAuthSignIn";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
const SignIn = () => {
    const nav = useNavigate();
    const location = useLocation();

    const handleSignup = (e) => {
        e.preventDefault();
        nav("/account/signup");
    };

    const handleEmailSignIn = (e) => {
        e.preventDefault();
        // Pass along the returnUrl state to email signin
        nav("/account/signin/email", { state: location.state });
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
            }}
        >
            <OAuthSignIn returnUrl={location.state?.returnUrl} />
            <div
                style={{
                    margin: "2rem 0",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    color: "#666",
                }}
            >
                Or
            </div>
            <Button
                variant="primary"
                className="mx-auto"
                style={{ height: "48px", fontSize: "1.1rem" }}
                onClick={handleEmailSignIn}
            >
                <FontAwesomeIcon
                    icon={faEnvelope}
                    style={{ marginRight: "8px" }}
                />
                Continue with Email
            </Button>
            <div className="mt-3 d-flex align-items-center justify-content-center gap-2">
                <span style={{ verticalAlign: "middle" }}>
                    Don't have an account?
                </span>
                <Button
                    type="button"
                    variant="link"
                    style={{ verticalAlign: "middle", padding: 0 }}
                    onClick={handleSignup}
                >
                    Sign up
                </Button>
            </div>
            <div className="mt-2">
                <Button
                    type="button"
                    variant="link"
                    style={{ padding: 0 }}
                    onClick={() => nav("/account/forgot-password")}
                >
                    Forgot Password?
                </Button>
            </div>
        </div>
    );
};

export default SignIn;
